<div class="board-container">
  <!-- Column Heading A-H -->
  <div class="board-header">
    <div class="header-cell"></div> <!-- Blank space for top left corner -->
  </div>
  <!-- Board Rows and Columns -->
  <div [ngClass]="{
    placedShips: true,
    board: true,
  }">
  <div *ngFor="let row of board; let i = index" class="board-row">
    <div *ngFor="let cell of row; let j = index" 
         class="board-cell" 
         (click)="onCellClick(i, j)"
         [ngStyle]="{
          width: cellSize + 'px',
          height: cellSize + 'px'
        }"
         (mouseenter)="onCellMouseEnter(i, j)" 
         (mouseleave)="onCellMouseLeave()"
         [ngClass]="{
           'hover': shouldHighlight(i, j).highlight && !shouldHighlight(i, j).invalid, 
           'hover-invalid': shouldHighlight(i, j).highlight && shouldHighlight(i, j).invalid
         }">
    </div>
  </div>
    <div *ngFor="let ship of placedShips" class="placed-ship" [ngStyle]="getPlacedShipStyle(ship)">
      <img [src]="getShipImageUrl(ship)" [style.width]="'100%'" [style.height]="'100%'" />
    </div>
  </div>

  <div class="ships-container">
    <ng-container *ngFor="let ship of ships">
      <div class="ship-container" *ngIf="!ship.isPlaced" (click)="selectShip(ship.id)"
        [class.ship-selected]="selectedShip?.id === ship.id">
        <img [src]="getShipImageUrl(ship)" class="ship" [style.width]="(ship.size * 20) + 'px'" />
      </div>
    </ng-container>
  </div>
  <button class="rotate-button" type="button" (click)="rotateSelectedShip()" *ngIf="selectedShip">
    <svg class="icon-12 fill-cerulean rotate-icon">
      <use href="../App_Themes/clearview-default/icons/utility/refresh.svg#refresh"></use>
    </svg> 
    <span cvLocalizedText langSection="Challenges_Create" langKey="Rotate">Rotate</span>
  </button>
  <div class="ready-label" *ngIf="placedShips.length === ships.length">
    <svg class="check-icon fill-ready">
      <use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use>
    </svg>
    <span cvLocalizedText langSection="Challenges" langKey="Ready">Ready</span>
  </div>
</div>
<div class="challengesFooterButtons">
  <button type="button" (click)="goBackFn()" class="back-button">
      <span cvLocalizedText langSection="Challenges" langKey="Back_Button">Back</span>
  </button>
  <button type="button" (click)="saveBattleBoatFn()" [disabled]="placedShips.length != ships.length" class="save-button">
      <span class="saveFormation" cvLocalizedText langSection="Challenges" langKey="save_formation">Save Formation</span>
  </button>
</div>